import { render, staticRenderFns } from "./FloatingContactUs.vue?vue&type=template&id=72404df0&"
import script from "./FloatingContactUs.vue?vue&type=script&lang=js&"
export * from "./FloatingContactUs.vue?vue&type=script&lang=js&"
import style0 from "./FloatingContactUs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports